import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Compass, Flame, MessageCircle, Wallet, User } from "lucide-react";
import { useUnreadCount, UnreadBadge } from "@/lib/unread";

const TABS = [
  { to: "/browse", label: "Discover", Icon: Compass, id: "browse" },
  { to: "/matches", label: "Matches", Icon: Flame, id: "matches" },
  { to: "/messages", label: "Messages", Icon: MessageCircle, id: "messages" },
  { to: "/wallet", label: "Wallet", Icon: Wallet, id: "wallet" },
  { to: "/me", label: "Profile", Icon: User, id: "profile" },
];

const HIDDEN = [/^\/$/, /^\/auth/, /^\/c\//, /^\/verify-email/, /^\/reset-password/, /^\/confirm-email/, /^\/messages\/.+/, /@velluto$/];

export const useTabBarVisible = () => {
  const { user } = useAuth();
  const { pathname } = useLocation();
  return !!user && !HIDDEN.some((r) => r.test(pathname));
};

export const MobileTabBar = () => {
  const { pathname } = useLocation();
  const visible = useTabBarVisible();
  const unread = useUnreadCount();
  if (!visible) return null;
  return (
    <>
      <div aria-hidden className="md:hidden h-[calc(4.5rem+env(safe-area-inset-bottom))]" />
      <nav data-testid="mobile-tab-bar"
        className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-ink/85 backdrop-blur-xl border-t border-white/8 pb-[env(safe-area-inset-bottom)]">
        <div className="grid grid-cols-5">
          {TABS.map(({ to, label, Icon, id }) => {
            const active = pathname === to || pathname.startsWith(`${to}/`);
            return (
              <Link key={to} to={to} data-testid={`tab-${id}`} aria-current={active ? "page" : undefined}
                className={`relative flex flex-col items-center justify-center gap-1 h-16 transition-colors active:scale-95 ${active ? "text-gold" : "text-text-muted"}`}>
                {active && <span className="absolute top-0 w-8 h-0.5 rounded-full bg-gold" />}
                <span className="relative">
                  <Icon size={21} strokeWidth={active ? 1.9 : 1.5} />
                  {id === "messages" && <UnreadBadge count={unread} testid="tab-messages-badge" className="absolute -top-1.5 -right-2.5" />}
                </span>
                <span className="text-[10px] tracking-wide">{label}</span>
              </Link>
            );
          })}
        </div>
      </nav>
    </>
  );
};
